import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import FaqSection from 'apps/promo/components/common/sections/FaqSection';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import { HeroSection } from 'apps/promo/components/common/sections/HeroSection';
import { TilesSection } from 'apps/promo/components/common/sections/TilesSection';
import TrustpilotSection from 'apps/promo/components/common/sections/TrustpilotSection';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { useGetQueryParams } from 'apps/promo/components/utils';
import { addScript, addStyleLink } from 'apps/promo/helpers/DOM';
import { getLangCountryPrefix, resolveArguments } from 'apps/promo/helpers/utils';

const EMBEDDED_PLAYER_CSS = '/embedded-player/ps3-embedded-player.1.48.2.css';
const EMBEDDED_PLAYER_JS = '/embedded-player/ps3-embedded-player.1.48.2.js';

const ReferralPageC3P0 = (props) => {
    const urlParams = useGetQueryParams();

    const noteText = props.heroNote;
    const prefix = getLangCountryPrefix(props.lang, props.country);

    const addPrefixToLinks = (text, prefix) => {
        return text?.replace(/<a\s+href="\/(.*?)">(.*?)<\/a>/g, (_, path, linkText) => `<a href="${prefix}/${path}">${linkText}</a>`);
    };

    const updatedNoteText = addPrefixToLinks(noteText, prefix);

    useEffect(() => {
        if (__isBrowser__) {
            addStyleLink(EMBEDDED_PLAYER_CSS);
            addScript(EMBEDDED_PLAYER_JS, () => {
                const { search } = window.location;
                const searchParams = Object.fromEntries(new URLSearchParams(search));
                if (window.embeddedPlayer && window.embeddedPlayer.init) {
                    window.embeddedPlayer.init(searchParams);
                }
                if (search && window.location.search !== search) {
                    const restoredUrl = `${window.location.pathname}${search}`;
                    window.history.replaceState(window.history.state, '', restoredUrl);
                }
            });
        }
    }, []);

    const getHeroTitle = () => {
        let heroTitle = props.heroTitle;
        if (urlParams?.n) {
            heroTitle = resolveArguments(props.heroTitlePersonal, urlParams?.n);
        } else if (props.inviterName) {
            heroTitle = resolveArguments(props.heroTitlePersonal, props.inviterName);
        }

        return heroTitle;
    };

    return (
        <>
            <PromoPageContainer bgColor="eggshell03" noIndent>
                {props.heroTitle && (
                    <HeroSection
                        isReferralC3P0Page
                        title={getHeroTitle()}
                        text={props.heroText}
                        bgImg={props.heroBgImg}
                        img={props.heroImg}
                        data={props.heroData}
                        note={updatedNoteText}
                        horizontalLayout
                        hasQrCode
                    />
                )}

                <ColoredSectionContainer>
                    {props.headline1Title && <HeadingSection title={props.headline1Title} text={props.headline1Text} />}

                    {props.lang && <TrustpilotSection lang={props.lang} />}

                    {props.headline2Title && <HeadingSection title={props.headline2Title} text={props.headline2Text} />}
                    {props.tiles && <TilesSection data={props.tiles} lang={props.lang} country={props.country} loadingLazy grayText />}
                </ColoredSectionContainer>

                {props.faqTitle && props.questions && <FaqSection title={props.faqTitle} questions={props.questions} noTopPadding />}
            </PromoPageContainer>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        inviterName: state.extra?.strapiApi?.inviterName,

        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroTitlePersonal: state.extra?.strapiApi?.hero_block_title_personal,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroData: state.extra?.strapiApi?.hero_block,
        heroBgImg: state.extra?.strapiApi?.hero_block?.bgImg,
        heroImg: state.extra?.strapiApi?.hero_block?.img,
        heroNote: state.extra?.strapiApi?.hero_block?.note,

        headline1Title: state.extra?.strapiApi?.headline_1?.title,
        headline1Text: state.extra?.strapiApi?.headline_1?.text,

        headline2Title: state.extra?.strapiApi?.headline_2?.title,
        headline2Text: state.extra?.strapiApi?.headline_2?.text,

        tiles: state.extra?.strapiApi?.tiles_section,

        faqTitle: state.extra?.strapiApi?.faq?.title,
        questions: state.extra?.strapiApi?.faq?.questions,

        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(ReferralPageC3P0));
